'use client';

import { ReactNode } from 'react';
import { motion, type HTMLMotionProps, type Variants } from 'motion/react';
import { VIEWPORT } from './tokens';

type Props = Omit<HTMLMotionProps<'article'>, 'children'> & {
  children?: ReactNode;
  staggerChildren?: number;
  delayChildren?: number;
  amount?: number;
};

export default function StaggerGroup({
  children,
  staggerChildren = 0.12,
  delayChildren = 0.05,
  amount = VIEWPORT.amount,
  ...rest
}: Props) {
  const variants: Variants = {
    hidden: {},
    visible: { transition: { staggerChildren, delayChildren } },
  };
  return (
    <motion.article
      initial='hidden'
      whileInView='visible'
      viewport={{ once: VIEWPORT.once, amount, margin: VIEWPORT.margin }}
      variants={variants}
      {...rest}
    >
      {children}
    </motion.article>
  );
}
